import { useAuth0 } from '@auth0/auth0-react';
import SoftBox from "components/SoftComponents/SoftBox";

import PropTypes from "prop-types";


const LogoutButton = ({ children }) => {
	const { logout, isAuthenticated } = useAuth0();

	return (
		isAuthenticated && (
			<SoftBox onClick={() => {
				logout(
					{ logoutParams: { returnTo: process.env.REACT_APP_AUTH0_CALLBACK_URL } }
				);
			}
			}>
				{children}
			</SoftBox>
		)
	)
}

// Typechecking props of the LogoutButton
LogoutButton.propTypes = {
	children: PropTypes.node.isRequired,
};


export default LogoutButton